import { createStructuredSelector } from 'reselect';
import { legendVisibilitySelector } from '@selectors/uiSelector';
import {
  anyFiltersChangedSelector,
  officesCountSelector,
  filteredOfficesCountSelector,
  presentationalFiltersSelector,
  areasFiltersSelector,
  presentationalOfficesCountSelector,
  searchValuesSelector,
  undergroundsFiltersSelector,
} from '@selectors/filterServicesSelector';

export const FiltersStructuredSelector = createStructuredSelector({
  presentationalFilters: presentationalFiltersSelector,
  areasFilters: areasFiltersSelector,
  undergroundsFilters: undergroundsFiltersSelector,
  searchValues: searchValuesSelector,
  legendOpened: legendVisibilitySelector,
  anyFiltersChanged: anyFiltersChangedSelector,
  allOfficesCount: officesCountSelector,
  filteredOfficesCount: filteredOfficesCountSelector,
  presentationalOfficesCount: presentationalOfficesCountSelector,
});

export type FiltersSelectorProps = {
  presentationalFilters: {
    services: [{ id: number; name: string; enabled: boolean }];
    areas: [{ id: number; name: string; enabled: boolean }];
    undergrounds: [{ id: number; name: string; enabled: boolean }];
  };
  searchValues: {
    services: string;
    areas: string;
    undergrounds: string;
  };
  areasFilters: [number];
  undergroundsFilters: [number];
  legendOpened: boolean;
  anyFiltersChanged: boolean;
  allOfficesCount: number;
  filteredOfficesCount: number;
  presentationalOfficesCount: number;
};
